import { createFileRoute } from '@tanstack/react-router';

import { GbReportCardsListPage } from '@/views/admin/gb-report-cards/gb-report-cards-list.tsx';

export const Route = createFileRoute('/admin/gb-report-cards')({
  component: GbReportCardsListPage,
});
